module.exports = __webpack_public_path__ + "static/img/funny_11.09d4c4be.jpg";